import { useEffect, useState } from "react";

import './FilterThiTruong.scss'

export default function FilterThiTruong(props) {
  const data = props?.data || [];
  const defaultData = props?.defaultData || [];
  const [tabActive, setTabActive] = useState(defaultData)

  useEffect(() => {
    if (defaultData) {
      setTabActive(defaultData)
    }
  }, [defaultData])

  useEffect(() => {
    if (props?.setSelectOption) {
      props?.setSelectOption(tabActive)
    }
  }, [tabActive])

  return (
    <div className='imnqqvodvr'>
      {
        data.map((item, key) => {
          return (
            <div onClick={() => setTabActive(item?.value)} key={key}
              className={`jmcbaswigm ${tabActive === item?.value ? 'ALuSYVPsaD' : ''}`}>{item?.name}</div>
          )
        })
      }
    </div>
  )
}